import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Actividades from "./pages/Actividades"; 
import Empresas from "./pages/Empresas";
import Eventos from "./pages/Eventos";
import Login from "./pages/Login";
import Registro from "./pages/Registro";
import Administrador from "./pages/administrador/Administrador";

export const RoutesCustom = ({ tipo }) => {
    if (tipo === "ROLE_REGISTRADO") {
        return (
            <>
                <Router >
                    <Routes>
                        <Route path="/" element={<Eventos />} exact />
                        <Route path="/empresas" element={<Empresas />} exact />
                        <Route path="/actividades" element={<Actividades />} exact />
                        <Route path="*" element={<Navigate to="/empresas" />} />
                    </Routes>
                </Router>
            </>
        );
    } else if (tipo === "ROLE_ADMIN") {
        return (
            <>
                <Router >
                    <Routes>
                        <Route path="/" element={<Administrador seccion={"panel"}/>} />
                        <Route path="/eventos" element={<Administrador seccion={"crearEvento"}/>} />
                        <Route path="/empresas" element={<Administrador seccion={"aprobarEmpresa"}/>} />
                        <Route path="/reuniones" element={<Administrador seccion={"crearReunion"}/>} />
                        <Route path="/analisis" element={<Administrador seccion={"analisis"}/>} />
                        <Route path="/configuracion" element={<Administrador seccion={"configuracion"}/>} />
                        <Route path="*" element={<Navigate to="" />} />
                    </Routes>
                </Router>
            </>
        );
    } else {
        return (
            <>
                <Router >
                    <Routes>
                        <Route path="/" element={<Login />} exact />
                        <Route path="/registrarse" element={<Registro />} exact />
                        <Route path="*" element={<Navigate to="" />} />
                    </Routes>
                </Router>
            </>
        );
    }
};
